<script>
	import VideoFeature from '$lib/Components/Layout/VideoFeature/VideoFeature.svelte';
	import thumb_mRgyjdhkWYQ from '$lib/Components/Youtube/images/mRgyjdhkWYQ.jpg';
</script>

<VideoFeature
	backgroundColor="blue"
	title="SEE IT IN ACTION"
	posterImageSrc={thumb_mRgyjdhkWYQ}
	src="https://www.youtube.com/watch?v=mRgyjdhkWYQ"
>
	<p>
		Our acrylic window inserts create a barrier of trapped air to keep cold out
		and heat in. See why acrylic aces our insulation test!
	</p>
</VideoFeature>
